import React, { useState, useEffect } from "react"; 
import axios from "../../utils/axiosConfig";
import { BASE_URL } from "../../utils/config";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Card, Modal, Form } from "react-bootstrap";
import "../Alumni/Alumni.css";

const Alumni = () => {

  const [alumniData, setAlumniData] = useState([]);
  const [selectedAlumni, setSelectedAlumni] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [batchFilter, setBatchFilter] = useState("All");

  const [zoomImage, setZoomImage] = useState(null);

  useEffect(() => {
    axios
      .get("/api/alumni")
      .then((res) => {
        setAlumniData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  /* ESC CLOSE FULLSCREEN */
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") setZoomImage(null);
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, []);

  const years = [
    "All",
    ...Array.from(
      new Set(alumniData.map((a) => a.year).filter(Boolean))
    ).sort((a, b) => b - a),
  ];

  const filtered =
    batchFilter === "All"
      ? alumniData
      : alumniData.filter((a) => String(a.year) === String(batchFilter));

  const sliderData =
    filtered.length < 4 ? [...filtered] : [...filtered, ...filtered];

  const openModal = (alumni) => {
    setSelectedAlumni(alumni);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedAlumni(null);
  };

  return (
    <section className="alumni-section">

      <Container>

        <h2 className="alumni-title text-center">
          NORTHANIAN DISTINGUISHED ALUMNI
        </h2>

        <p className="alumni-description text-center">
          Our alumni community represents the excellence and spirit of our
          school. From leaders in technology and science to innovators in
          arts, sports and public service, our former students continue to
          inspire the next generation with their achievements.
        </p>

        {/* FILTER */}
        <div className="alumni-filter">
          <Form.Select
            value={batchFilter}
            onChange={(e) => setBatchFilter(e.target.value)}
          >
            {years.map((y, i) => (
              <option key={i} value={y}>
                {y === "All" ? "All Batches" : `Batch ${y}`}
              </option>
            ))}
          </Form.Select>
        </div>

        {/* CAROUSEL */}
        <div className="alumni-carousel">
          <div className="alumni-track">
            {sliderData.map((alumni, index) => (
              <Card key={index} className="alumni-card" onClick={() => openModal(alumni)}>
                <div className="alumni-img-wrap">
                  <img
                    src={`${BASE_URL}/uploads/alumni/${alumni.image}`}
                    alt={alumni.name}
                  />
                </div>
                <Card.Body>
                  <h5 className="alumni-name text-center">
                    {alumni.name}
                  </h5>
                  <p className="alumni-batch">
                    Batch {alumni.year || "N/A"}
                  </p>
                  <p className="alumni-about">
                    {alumni.about ? alumni.about.slice(0, 80) + "..." : ""}
                  </p>
                </Card.Body>
              </Card>
            ))}
          </div>
        </div>

      </Container>

      {/* MODAL */}
      <Modal show={showModal} onHide={closeModal} centered dialogClassName="custom-modal">
        {selectedAlumni && (
          <>
            <Modal.Header>
              <Modal.Title>{selectedAlumni.name}</Modal.Title>
              <button className="btn btn-secondary ms-auto" onClick={closeModal}>
                Close
              </button>
            </Modal.Header>

            <Modal.Body>
              <div className="modal-alumni">

                {/* IMAGE */}
                <div className="modal-image">
                  <img
                    src={`${BASE_URL}/uploads/alumni/${selectedAlumni.image}`}
                    alt={selectedAlumni.name}
                    onClick={() =>
                      setZoomImage(`${BASE_URL}/uploads/alumni/${selectedAlumni.image}`)
                    }
                  />
                </div>

                {/* TEXT */}
                <div className="modal-text">
                  <p className="alumni-batch">
                    Batch {selectedAlumni.year || "N/A"}
                  </p>
                  <p>{selectedAlumni.about}</p>
                </div>

              </div>
            </Modal.Body>
          </>
        )}
      </Modal>

      {/* FULLSCREEN ZOOM */}
      {zoomImage && (
        <div className="fullscreen-overlay" onClick={() => setZoomImage(null)}>
          <img src={zoomImage} alt="Zoom" />
        </div>
      )}

    </section>
  );
};

export default Alumni;